var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:("rounded-circle " + (_vm.type.toLowerCase())),attrs:{"alt":"image","width":_vm.width,"src":_vm.getBlockie(_vm.address)}})}
var staticRenderFns = []

export { render, staticRenderFns }